/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Country list
 */
export interface CountryResult { 
    /**
     * Country name. Examples: España, Reino Unido...
     */
    name?: string;
    /**
     * Continent code. Examples: EU, AF...
     */
    continentCode?: string;
    /**
     * Country ISO Alpha2 code. Examples: ES, GB...
     */
    isoAlpha2?: string;
    /**
     * Country ISO Alpha3 code. Examples: ESP, GBR...
     */
    isoAlpha3?: string;
    /**
     * Country ISO Numeric code. Examples: 724, 826...
     */
    isoNumeric?: number;
    /**
     * Country Fips code. Examples: SP, UK...
     */
    fips?: string;
    /**
     * Country languages. Examples: es-ES, ca, gl, eu, oc...
     */
    languages?: string;
    /**
     * Country capital code. Examples: MADRID, LONDON...
     */
    capitalCode?: string;
    /**
     * Country code Top Level Domains. Examples: .es, .uk...
     */
    tld?: string;
    /**
     * Country currency code. Examples: EUR, GBP...
     */
    currency?: string;
    /**
     * Country currency name. Examples: Euro, Pound...
     */
    currencyName?: string;
    /**
     * Country currency symbol. Examples: €, $...
     */
    currencySymbol?: string;
    /**
     * Country phone prefix. Examples: 34, 44...
     */
    phonePrefix?: string;
    /**
     * Country postal code format. Examples: #####, @# #@@|@## #@@|@@# #...
     */
    postalCodeFormat?: string;
    /**
     * Country postal code RegEx. Examples: ^(d{5})$, ^([Gg][Ii][Rr]s?0[Aa...
     */
    postalCodeRegEx?: string;
    /**
     * Legal age. Examples: 18, 21...
     */
    legalAge?: number;
}

